"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  textBox: {
    boxShadow: theme.shadows[25].z12,
    padding: theme.spacing(3)
  }
}));
const Video = props => {
  const {
    title,
    text,
    media
  } = props.data;
  const css = useStyles();
  const {
    filename,
    size: duration
  } = (0, _lodash.first)(media);
  function formatTime(time) {
    const hrs = ~~(time / 3600);
    const mins = ~~(time % 3600 / 60);
    const secs = ~~time % 60;
    let ret = "";
    if (hrs > 0) {
      ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }
    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
  }
  const time = duration ? formatTime(duration) : null;
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    md: 8
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "video",
    style: {
      position: "relative",
      paddingBottom: "56.25%",
      paddingTop: 25,
      height: 0
    }
  }, /*#__PURE__*/_react.default.createElement("iframe", {
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%"
    },
    title: "ytb",
    src: "https://www.youtube.com/embed/" + filename,
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    loading: "lazy"
  }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    md: 4,
    className: css.textBox
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h3",
    color: "secondary"
  }, title), time ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption"
  }, time, " min") : "", /*#__PURE__*/_react.default.createElement(_Box.default, {
    my: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    dangerouslySetInnerHTML: {
      __html: text
    }
  })))));
};
var _default = exports.default = Video;